module.exports = __webpack_public_path__ + "img/denied.59979858.svg";